<!-- 
  底层背景板子
 -->
<template>
  <div class="bottom_back">
    <!-- <img class="top_border" src="@/assets/img/home_border1.png"/>
    <img class="bottom_border" :style="borderStyle" src="@/assets/img/home_border2.png" alt=""> -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  name:'bottomBack',
  props:{
    // 底部border图片的样式
    borderStyle:{
      type:Object,
      default:{}
    }
  }
}
</script>

<style lang="less" scoped>
.bottom_back{
  width: 950px;
  height: 2767.95vh * @vh;
  // background: rgba(0, 0, 0, 0.3);
  position: relative;
  .top_border{
    width:874px;
    height: 27vh * @vh;
    position: absolute;
    top: -14vh * @vh;
    left: 50%;
    transform: translate(-50%, 0);
  }
  .bottom_border{
    width:929px;
    height: 21vh * @vh;
    position: absolute;
    bottom: 0;
    transform: scaleX(-1);
  }
}
</style>